import { defaultInspectPlanDto, InspectPlanDto } from "src/dtos/inspectplan/inspctPlanDto";
import { defaultEquipment, EquipmentDto } from "src/dtos/equipment/equipmentDto";


export interface EQM2010_R01HeaderDto extends EquipmentDto {

}

export interface EQM2010_R01DetailDto extends InspectPlanDto {
    /** 목록 길이 */
    listLength: number;
    
    // 설비 관련 필드
    /** 설비명 */
    equipmentNm: string;
    /** 설비유형 (프레스, 용접, 금형 등) */
    eqmType: string;
    
    // 점검 관련 필드
    /** 점검명 */
    inspectNm: string;
    /** 점검방법 */
    inspectMethod: string;
    /** 점검유형 (점검, 세척, 검교정) */
    inspectType: string;
    /** 결과유형 (문자, 숫자, OK) */
    inspectValue: string;
    /** 결과유형명 */
    inspectValueNm: string;

    /** 계획 존재 여부 (Y/N) */
    planYn?: string;

    // UI 상태 관리 필드
    /** 새로 삽입된 데이터 여부 */
    inserted: boolean;
    /** 수정된 데이터 여부 */
    isModified: boolean;
    
    // 그리드 인덱스 관리 필드
    /** 값 인덱스 */
    valueIndex: number;
    /** 순서 인덱스 */
    orderIndex: number;
    /** 순서 인덱스 시퀀스 */
    orderIndexSeq: number;
}

/**
 * EQM2010_R01Dto의 기본값
 * 모든 필드를 초기값으로 설정하여 새 객체 생성 시 사용
 */
export const defaultEQM2010_R01DetailDto: EQM2010_R01DetailDto = {
    ...defaultInspectPlanDto,
    listLength: 0,
    equipmentNm: '',
    eqmType: '',
    inspectNm: '',
    inspectMethod: '',
    inspectType: '',
    inspectValue: '',
    inspectValueNm: '',
    planYn: 'N',

    inserted: false,
    isModified: false,
    
    valueIndex: 0,
    orderIndex: 0,
    orderIndexSeq: 0,
}

export const defaultEQM2010_R01HeaderDto : EQM2010_R01HeaderDto = {
    ...defaultEquipment,
    equipmentNm: '',
    equipmentType: '',
    workplaceCd: '',
    equipmentSeq: 0,
    displaySeq: 0,
    compCd: '',
    compNm: '',
    eqmOrgcd: '',
    eqmOrgNm: '',
    eqmPerson: '',
    eqmPersonNm: '',
    eqmPower: 0,
    eqmVolt: 0,
}